import {FetchAction, FetchState} from "App/services";
import {ActionType, ApiErrorType} from "App/constants";
import {Authentication} from "App/services/auth";

export interface AuthState {
    error: ApiErrorType
    submitting: boolean
    done: boolean
    authentication?: Authentication
}

export function authReducer(state: AuthState | null = null, action: FetchAction) {
    console.log("start authReducer() "+state);

    switch (action.type) {
        case ActionType.LOGOUT: {
            switch (action.state) {
                case FetchState.FETCHING: {
                    return {
                        ...state,
                        error: ApiErrorType.NONE,
                        submitting: true,
                        done: false
                    }
                }
                case FetchState.SUCCESS: {
                    return {
                        error: ApiErrorType.NONE,
                        submitting: false,
                        done: true,
                        authentication: undefined
                    }
                }
                case FetchState.FAILURE: {
                    return {
                        error: action.payload.name,
                        submitting: false,
                        done: false,
                        authentication: undefined
                    }
                }
                default:
                    return state;
            }
        }
        case ActionType.START_LOGIN: {
            return {
                error: ApiErrorType.NONE,
                submitting: false,
                done: false
            }
        }
        case ActionType.LOGIN: {
            switch (action.state) {
                case FetchState.FETCHING: {
                    return {
                        ...state,
                        error: ApiErrorType.NONE,
                        submitting: true,
                        done: false
                    }
                }
                case FetchState.SUCCESS: {
                    return {
                        error: ApiErrorType.NONE,
                        submitting: false,
                        done: false,
                        authentication: action.payload
                    }
                }
                case FetchState.FAILURE: {
                    return {
                        error: action.payload.name,
                        submitting: false,
                        done: false,
                        authentication: undefined
                    }
                }
                default:
                    return state;
            }
        }
        case ActionType.SELECT_ACCOUNT: {
            switch (action.state) {
                case FetchState.SUCCESS: {
                    return {
                        ...state,
                        error: ApiErrorType.NONE,
                        submitting: false,
                        done: true,
                        account: action.payload
                    }
                }
                case FetchState.FAILURE: {
                    return {
                        error: action.payload.name,
                        submitting: false,
                        done: false,
                        authentication: undefined,
                        account: undefined
                    }
                }
                default:
                    return state;
            }
        }
        case ActionType.CANCEL_LOGIN: {
            return null
        }
        case ActionType.RESET_LOGIN: {
            return {
                error: ApiErrorType.NONE,
                submitting: false,
                done: false
            }
        }
        default:
            return state
    }
}

export function startLogin(): any {
    return {
        type: ActionType.START_LOGIN,
    }
}

export function cancelLogin(): any {
    return {
        type: ActionType.CANCEL_LOGIN,
    }
}

export function resetLogin(): any {
    return {
        type: ActionType.RESET_LOGIN,
    }
}



// WEBPACK FOOTER //
// ./src/services/reducers/auth.ts